<div class="inthraction-graph-dialog-wrapper">
<inthraction-inthraction-graph [employee]="employee" [configuration]="{ratesOthers:ratesOthers}"></inthraction-inthraction-graph>
</div>
